'use strict';

angular.module('far.admin')
	.controller('TokenUsersController', function ($log, $http, $window, form, tokenUsersForm, showModalMessage, softdeleteable, fileUploadFilters) {
		var vm = {
			progress: true,
			tokenUsersModel: tokenUsersForm,
			submit: submit,
			getDocumentUrl: getDocumentUrl,
			getTokenUsers: getTokenUsers,
            deleted: false,
            delete: function() {
                vm.deleted = true;

                softdeleteable.delete(vm.tokenUsers.id);
            },
            restore: function() {
                vm.deleted = false;

                softdeleteable.restore(vm.tokenUsers.id);
            },
            formRoute: form('form'),
		};

	
	
        vm.tokenUsersModel.$fields.documentsFiles.uploader.onSuccessItem = function (item, response) {
            vm.tokenUsersModel.documents_files.push(response);
        };
		vm.tokenUsersModel.$fields.documentsFiles.uploader.removeFromQueue = function (value) {
			var index = this.getIndexOfItem(value);
			var item = this.queue[index];

			if (item.isUploading) {
				item.cancel();
			} else {
				vm.documents_files.splice(index, 1);
			}

			this.queue.splice(index, 1);
			item._destroy();

			this.progress = this._getTotalProgress();
		};
      
		function getTokenUsers() {
			softdeleteable.setModel(tokenUsers);

				vm.tokenUsers = tokenUsers.new({
					slides_files: [],
					documents_files: []
				});
				vm.progress = false;
		
		}
      

		function getDocumentUrl(file_id) {
			return Routing.generate('api_upload_get_file', {fileStorage: file_id});
		}

	
		function submit() {
			// vm.mountainRoute.documents_files = vm.mountainRoute.documents_files.concat(
			// 	vm.documents_files
			// 		.filter(function (document) {
			// 			return document.isUploaded;
			// 		})
			// 		.map(function (document) {
			// 			return document.serverData;
			// 		})
			// );
			// vm.mountainRouteModel.$fields.documentsFiles.uploader.clearQueue();

		
		

			vm.tokenUsers.save()
				.then(function (response) {
					$window.location.href = Routing.generate('page_token_users_index');
				})
				.catch(function (response) {
					$log.error(response);
					showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
				});
		}

		return vm;
	});